import { createListFilters } from 'app/components'

export type LogsUsuarioFilters = {
  /** Nome do usuário (busca parcial). */
  nome: string
}

export const { ListFiltersProvider, useListFilters } = createListFilters<LogsUsuarioFilters>({
  nome: '',
})
